import mime from "mime";

export function downloadCSV(filename: string, csvString: string) {
  const csvMimeType = mime.getType(".csv");
  const blob = new Blob([csvString], {
    ...(csvMimeType ? { type: `${csvMimeType};charset=utf-8;` } : {}),
  });
  filename = filename + ".csv";
  downloadBlob(filename, blob);
}

export function downloadXLSX(filename: string, data: any) {
  const xlsMimeType = mime.getType(".xlsx");
  const blob = new Blob([data], {
    ...(xlsMimeType ? { type: xlsMimeType } : {}),
  });
  filename = filename + ".xlsx";
  downloadBlob(filename, blob);
}

export function downloadPDF(filename: string, pdfString: string) {
  const pdfMimeType = mime.getType(".pdf");
  const blob = new Blob([pdfString], {
    ...(pdfMimeType ? { type: `${pdfMimeType};charset=utf-8;` } : {}),
  });
  filename = filename + ".pdf";
  downloadBlob(filename, blob);
}

export function downloadFile(filename: string, data: any) {
  const blob = new Blob([data], { type: "charset=utf-8;" });
  downloadBlob(filename, blob);
}

/**
 * Initiate a file download at a URL by creating a temporary hidden link element with a download attribute, then virtually clicking it. The DOM node is then removed.
 * @param {string} link a valid GET link for a file
 * @param {string} fileName optionally specify the name of the downloaded file. If left unspecified, the name of the file will be determined by the link provided. NOTE: this only works for files from the same origin – has no effect otherwise – use a fetch request to GET the file and feed it into a blob that can be renamed instead.
 */
export function downloadLink(link: string, fileName?: string) {
  const linkElement = document.createElement("a");

  linkElement.setAttribute("href", link);
  linkElement.setAttribute("download", fileName ?? "");
  linkElement.hidden = true;
  document.body.appendChild(linkElement);
  linkElement.click();

  // remove the element after 1 second
  setTimeout(() => {
    linkElement.remove();
  }, 1000);
}

export function downloadBlob(filename: string, blob: Blob) {
  const link = document.createElement("a");

  if (link.download === undefined) {
    return;
  }

  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename || "");
  link.hidden = true;
  link.click();

  // destroy the object URL after 10 seconds
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
